import React, { useCallback, useEffect, useState, useRef } from "react";
import MainHeader from "./MainHeader";
import Sidebar from "./Sidebar";
import Multiselect from "multiselect-react-dropdown";
import axios from "axios";
import DateRangePicker from "./DateRangePicker";
// import DateRangePicker from "react-daterange-picker";
import { SlMagnifier } from "react-icons/sl";
import { useMsal } from "@azure/msal-react";
import Meet from "../images/Meeting.png";
import { getToken } from "../authConfig";

import { isBefore } from "date-fns";
import { DateTime } from "luxon";
import { debounce } from "lodash";

const Teams = () => {
  const [users, setUsers] = useState([]);
  const { instance, accounts } = useMsal();
  const [formData, setFormData] = useState({
    subject: "",
    startDate: "",
    endDate: "",
    users: [],
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const handleSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };
  const [showSuccess, setShowSuccess] = useState(false);
  const [errors, setErrors] = useState({});
  const [successEventCount, setSuccessEventCount] = useState(0);
  const [scheduleMeet, setScheduleMeet] = useState();
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dateRange, setDateRange] = useState({ startDate: "", endDate: "" }); // Track date range
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [totalRecords, setTotalRecords] = useState(0); // Total records count
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const dateRangeRef = useRef(null); // Reference to DateRangePicker

  useEffect(
    () => {
      const fetchUsers = async () => {
        const token = await getToken(instance, accounts);
        if (!token) return;
        try {
          const response = await axios.get(
            "https://devapi.drtestdash.com/disaster-recovery/api/event/AZURE/tenant-users",
            {}
          );
          setUsers(
            response?.data?.data?.value?.map((user) => ({
              name: user.displayName,
              id: user.id,
              email: user.mail,
            }))
          );
        } catch (error) {
          console.log("err", error);
        }
      };
      fetchUsers();
    }, // eslint-disable-next-line
    []
  );

  const formatDateForAPI = (date) => {
    const d = new Date(date);
    const pad = (num) => num.toString().padStart(2, "0");

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
      d.getDate()
    )}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
      d.getSeconds()
    )}.0000000`;
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const fetchMeetings = useCallback(
    debounce(async (range, page) => {
      setLoader(true);
      try {
        const skip = (page - 1) * pageSize; // Calculate skip based on page number
        const params = {
          // ...(term && { subject: term }),
          ...(range?.startDate && { startDate: range.startDate }),
          ...(range?.endDate && { endDate: range.endDate }),
          skip,
        };
        console.log("API call parameters:", params);

        const response = await axios.get(
          "https://devapi.drtestdash.com/disaster-recovery/api/event/AZURE/list",
          // {
          //   params: term ? { subject: term } : {},
          // }
          { params }
        );
        setScheduleMeet(response?.data?.data?.value);
        setTotalRecords(response?.data?.data?.totalRecords || 0); // Set total records from API
        setFilteredData(response?.data?.data?.value);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoader(false);
      }
    }, 700),
    []
  );

  useEffect(() => {
    fetchMeetings(dateRange, currentPage);
    return fetchMeetings.cancel; // Cleanup debounce on unmount
  }, [fetchMeetings, successEventCount, dateRange, currentPage]);

  const handlePageChange = (page) => {
    if (page < 1) return; // Prevent navigating to pages below 1
    setCurrentPage(page); // This will trigger useEffect
  };

  console.log("schedule meet length", scheduleMeet?.length);
  const totalPages = Math.ceil(totalRecords / pageSize);

  const isLastPage =
    scheduleMeet?.length < pageSize || currentPage === totalPages;

  const getPageNumbers = () => {
    const range = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total pages are less than or equal to maxVisiblePages
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      if (currentPage <= 3) {
        // Show first few pages and ellipsis
        range.push(1, 2, 3, 4, "...", totalPages);
      } else if (currentPage > totalPages - 3) {
        // Show ellipsis and last few pages
        range.push(
          1,
          "...",
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages
        );
      } else {
        // Show ellipsis, current page in the middle, and surrounding pages
        range.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return range;
  };

  // const handleSearchChange = (event) => {
  //   setSearchTerm(event.target.value); // Update search term
  // };
  const handleSearch = (e) => {
    const data = e.target.value.toLowerCase();
    setSearchData(data);
    const result = filteredData.filter((item) =>
      item.subject.toLowerCase().includes(data)
    );
    setScheduleMeet(result);
  };

  // const handleDateChange = (range) => {
  //   console.log("Raw Date Range:", range); // Debug log

  //   setDateRange({
  //     startDate: range?.startDate ? formatDateForAPI(range.startDate) : "",
  //     endDate: range?.endDate ? formatDateForAPI(range.endDate) : "",
  //   });
  // };

  // const handleDateChange = (range) => {
  //   if (!range.startDate || !range.endDate) {
  //     setDateRange({ startDate: "", endDate: "" }); // Reset the date range
  //   } else {
  //     setDateRange({
  //       startDate: formatDateForAPI(range.startDate),
  //       endDate: formatDateForAPI(range.endDate),
  //     });
  //   }
  // };

  const handleDateChange = (range) => {
    setDateRange({
      startDate: range?.startDate ? formatDateForAPI(range.startDate) : "",
      endDate: range?.endDate ? formatDateForAPI(range.endDate) : "",
    });
  };

  const formatDateTime = (isoDateTime) => {
    // Parse the UTC date-time string using luxon
    const date = DateTime.fromISO(isoDateTime, { zone: "utc" });

    // Convert the date to local time
    const localDate = date.setZone("local"); // automatically detects the user's local time zone

    // Format the date and time to local
    const formattedDate = localDate.toFormat("dd/MM/yyyy"); // day/month/year format
    const formattedTime = localDate.toFormat("hh:mm a"); // 12-hour format with AM/PM

    return { formattedDate, formattedTime }; // Now this handles all time zone issues including DST
  };

  // Map meetings with formatted dates and times
  const formattedMeetings = scheduleMeet?.map((item) => {
    const { formattedDate: startDate, formattedTime: startTime } =
      formatDateTime(item.start.dateTime);
    const { formattedDate: endDate, formattedTime: endTime } = formatDateTime(
      item.end.dateTime
    );

    return {
      ...item,
      startDate,
      startTime,
      endDate,
      endTime,
    };
  });

  const validateForm = () => {
    const newErrors = {};
    const currentDate = new Date();

    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";
    if (!formData.startDate) {
      newErrors.startDate = "Start date is required.";
    } else if (isBefore(new Date(formData.startDate), currentDate)) {
      newErrors.startDate = "The selected start date is in the past.";
    }

    if (!formData.endDate) {
      newErrors.endDate = "End date is required.";
    } else if (new Date(formData.startDate) >= new Date(formData.endDate)) {
      newErrors.endDate = "End date must be after the start date.";
    }
    if (!formData.users.length)
      newErrors.users = "At least one user must be selected.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return true if no errors
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "", // Clear error for the field
    }));
  };

  const handleSelect = (selectedList) => {
    setFormData((prev) => ({
      ...prev,
      users: selectedList,
    }));
    setErrors((prev) => ({
      ...prev,
      users: "", // Clear error for users
    }));
  };

  const handleRemove = (selectedList) => {
    setFormData((prev) => ({
      ...prev,
      users: selectedList,
    }));
    setErrors((prev) => ({
      ...prev,
      users: "", // Clear error for users
    }));
  };

  const handleSendInvite = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    const attendees = formData.users.map((user) => {
      return user.email;
    });

    // Format `startDate` and `endDate` into ISO 8601 with UTC
    const startDateTime = new Date(formData.startDate).toISOString(); // Ensures format like "2024-12-08T10:00:00Z"
    const endDateTime = new Date(formData.endDate).toISOString();

    const payload = {
      subject: formData.subject,
      startDateTime: startDateTime,
      endDateTime: endDateTime,
      attendees,
      location: "Teams Room",
      isOnlineMeeting: true,
    };

    setLoading(true);

    try {
      const response = await axios.post(
        "https://devapi.drtestdash.com/disaster-recovery/api/event/AZURE/schedule",
        payload,
        {}
      );
      console.log(response, "res");

      setShowSuccess(true); // Show success popup
      setLoading(false);

      // get event data
      setSuccessEventCount(successEventCount + 1);

      setFormData({
        subject: "",
        startDate: "",
        endDate: "",
        users: [],
      });

      setTimeout(() => setShowSuccess(false), 3000); // Hide popup after 3 seconds
    } catch (error) {
      console.error("Error creating event:", error);
    }
  };

  return (
    <>
      {" "}
      <Sidebar onToggle={handleSidebarToggle} />
      <div
        className={`content p-5 ${
          isSidebarOpen ? "content-expanded" : "content-collapsed"
        }`}
      >
        <div className="header">
          <MainHeader className="mb-5"></MainHeader>

          <div className="me-2 mt-0">
            <div className="row align-items-center justify-content-between mt-3">
              <div className="col-md-7 ps-5 mt-5">
                <div className="d-flex justify-content-between items-center mb-2">
                  <div>
                    <label htmlFor="selectmeeting">Search the Meetings</label>
                    <div className="input-group w-100">
                      <input
                        type="text"
                        placeholder="Search..."
                        className="form-control"
                        value={searchData}
                        onChange={handleSearch}
                      />
                      <div className="input-group-append">
                        <span className="input-group-text h-100">
                          <SlMagnifier />
                        </span>
                      </div>
                    </div>
                  </div>

                  <DateRangePicker
                    onDateChange={handleDateChange}
                    ref={dateRangeRef}
                  />
                  {/* <button
                    className="btn btn-secondary"
                    onClick={resetDateFilter}
                  >
                    Clear Filters
                  </button> */}
                </div>

                {formattedMeetings?.length > 0 ? (
                  <div className="card">
                    <h4 className="color-teams card-header mb-1 pb-2">
                      {" "}
                      Upcoming Meetings
                    </h4>

                    {loader ? ( // Show loader while loading
                      <div className="col-md-12 loader-container d-flex justify-content-center align-items-center">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="card-body overflowScroll">
                        {formattedMeetings?.map((eventData) => (
                          <div className="bg-white p-3 rounded shadow mb-4">
                            <h6>{eventData.subject}</h6>
                            <p>
                              Start Time -{eventData.startDate}{" "}
                              {eventData.startTime}
                            </p>
                            <p>
                              End Time -{eventData.endDate} {eventData.endTime}
                            </p>
                            <p>
                              {" "}
                              Meeting Link :
                              <a
                                className="color-teams trim-link"
                                href={eventData.onlineMeeting.joinUrl}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {eventData.onlineMeeting.joinUrl}
                              </a>
                            </p>
                          </div>
                        ))}
                      </div>
                    )}

                    <div className="card-footer mt-2 d-flex justify-content-end">
                      <nav aria-label="...">
                        <ul class="pagination">
                          <li
                            className={`page-item me-3 ${
                              currentPage === 1 ? "disabled" : ""
                            }`}
                          >
                            <button
                              className="page-link button-17"
                              onClick={() => handlePageChange(currentPage - 1)}
                              disabled={currentPage === 1}
                            >
                              Previous
                            </button>
                          </li>

                          {/* Page Numbers */}
                          {getPageNumbers().map((page, index) =>
                            page === "..." ? (
                              <li key={index} className="page-item disabled">
                                <span className="page-link">...</span>
                              </li>
                            ) : (
                              <li
                                key={index}
                                className={`page-item ${
                                  currentPage === page ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link button-17"
                                  onClick={() => handlePageChange(page)}
                                >
                                  {page}
                                </button>
                              </li>
                            )
                          )}

                          {/* Next Button */}
                          <li
                            className={`page-item ${
                              currentPage === Math.ceil(totalRecords / pageSize)
                                ? "disabled"
                                : ""
                            }`}
                          >
                            <button
                              className="page-link button-17"
                              onClick={() => handlePageChange(currentPage + 1)}
                              disabled={isLastPage}
                            >
                              Next
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  </div>
                ) : searchData.trim() ? (
                  <div className="card">
                    <h4 className="color-teams card-header mb-1 pb-2">
                      Upcoming Meetings
                    </h4>
                    <div className="card-body overflowScroll">
                      <p className="text-center mt-5">
                        No results found for "{searchData}"
                      </p>
                    </div>
                  </div>
                ) : (
                  <img src={Meet} alt={Meet} className="w-100 p-5"></img>
                )}
              </div>

              <div className="col-md-4 bg-white rounded p-4 shadow m-80">
                {" "}
                <div className="text-center border-bottom mb-3">
                  <h5 className="fw-bold mb-3">Invite your team</h5>
                </div>
                <div className="form-container">
                  <form className="register-form" onSubmit={handleSendInvite}>
                    <div>
                      <label className="fw-bold">
                        Enter the Subject <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Untitled"
                        name="subject"
                        value={formData.subject}
                        onChange={handleInputChange}
                      />
                      {errors.subject && (
                        <small className="text-danger">{errors.subject}</small>
                      )}
                    </div>
                    <div>
                      <label className="fw-bold mt-3">
                        Team Members <span className="text-danger">*</span>
                      </label>
                      <Multiselect
                        options={users} // Options to display in the dropdown
                        selectedValues={formData.users} // Preselected options
                        onSelect={handleSelect} // Function to handle selected items
                        onRemove={handleRemove} // Function to handle removal of items
                        displayValue="name" // Property name to display
                        placeholder="Select the user"
                        className="mb-2"
                        showArrow="true"
                        // loading="true"
                        showCheckbox="true"
                        hidePlaceholder="true"
                        avoidHighlightFirstOption="true"
                      />
                      {errors.users && (
                        <small className="text-danger">{errors.users}</small>
                      )}
                    </div>
                    <div>
                      <label className="fw-bold mt-2">
                        Start Date & time <span className="text-danger">*</span>
                      </label>

                      <input
                        className="form-control"
                        placeholder="Start Date"
                        type="datetime-local"
                        name="startDate"
                        onChange={handleInputChange}
                        value={formData.startDate}
                      />

                      {errors.startDate && (
                        <small className="text-danger">
                          {errors.startDate}
                        </small>
                      )}
                    </div>
                    <div>
                      <label className="fw-bold mt-3">
                        End Date & time <span className="text-danger">*</span>
                      </label>
                      <input
                        className="form-control "
                        type="datetime-local"
                        placeholder="End Date"
                        name="endDate"
                        value={formData.endDate}
                        onChange={handleInputChange}
                      />
                      {errors.endDate && (
                        <small className="text-danger">{errors.endDate}</small>
                      )}
                    </div>

                    <div className="d-flex justify-content-between">
                      <button
                        className="btn btn-outline-secondary mt-3"
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          setFormData({
                            subject: "",
                            startDate: "",
                            endDate: "",
                            users: [],
                          });
                          setErrors({});
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn text-dark mt-3 bg-blue-500"
                        type="submit"
                        // disabled={isPastDate}
                      >
                        Send Invite
                      </button>
                    </div>
                  </form>
                </div>
                {showSuccess && (
                  <div className="alert alert-success mt-3">
                    Event created successfully!
                  </div>
                )}
                {loading && (
                  <div className="d-flex justify-content-center my-4">
                    <div className="spinner-border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Teams;
